// extracted by mini-css-extract-plugin
module.exports = {"stickyHeader":"VehicleDefectsTable_stickyHeader_SS4Q8","q-table__top":"VehicleDefectsTable_q-table__top_1Prx6","q-table__bottom":"VehicleDefectsTable_q-table__bottom_hmX7z"};